import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import {
  selectBrand,
  selectContent,
  selectCustomer,
  logoutCustomer,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  ButtonLink,
  Content,
  DeleteAccount,
  HeaderDefault,
  Main,
  PageContainer,
  PageTitle,
  VerifyAccount,
  VerifyAccountTpls,
} from 'components'
import AccountSettingsButtons from './AccountSettingsButtons'

const AccountSettingsLogOut = styled.div`
  margin: 1rem 0 2rem;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.small};
  }
`

const AccountSettings = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { title: siteTitle, tpls } = useAppSelector(selectBrand) || {}
  const { accountSettings: config } = useAppSelector(selectContent) || {}
  const { auth, profile } = useAppSelector(selectCustomer)

  useEffect(() => {
    if (!auth) return navigate('/guest')
  }, [auth, navigate])

  return profile ? (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle {...config}>
              <AccountSettingsLogOut>
                <p>
                  <ButtonLink
                    onClick={() => dispatch(logoutCustomer(undefined))}
                  >
                    Log out of your account
                  </ButtonLink>
                </p>
                {tpls ? (
                  <VerifyAccountTpls style={{ margin: '4rem 0 0' }} />
                ) : (
                  <VerifyAccount style={{ margin: '2rem 0 0' }} />
                )}
                {}
              </AccountSettingsLogOut>
            </PageTitle>
            <AccountSettingsButtons />
            <DeleteAccount />
          </PageContainer>
        </Main>
      </Content>
    </>
  ) : null
}

export default AccountSettings
